import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceHome } from "./-home/WorkspaceHome";

export const Route = createFileRoute("/$workspace/")({
  staticData: { title: "Projects" },
  component: WorkspaceHome,
});
